import React, { Component } from 'react'

class Dashresults extends Component{

	render(){
		return (
			<li>
		      	<p className="c-title c-title--color-white c-title--family-black c-title--size-big">{ this.props.number } <span className="c-dashresults__list--item-number--complement">{ this.props.numberComplement }</span></p>
		      	<p className="c-title c-title--color-white c-title--weight-bold c-title--size-small">{ this.props.text } <br /> { this.props.text2 }</p>
		    </li>
		)
	}

}

export default Dashresults


// WEBPACK FOOTER //
// ./src/components/Dashresults.js